import styled from 'styled-components';
import { Link } from 'react-router-dom';

const RouterLink = styled(Link)`
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
`;

export default RouterLink;
